// This file is in javascript & not json because we cant add linebreaks in json

import React from 'react';

export const NPSFeatured = [
	{
		id: 1,
		heading: 'How to invest in National Pension Scheme via Moneyfront',
		description: [
			'Moneyfront has partnered with Religare Broking Limited to offer the National Pension Scheme (NPS). With a smooth and fast web and mobile platform, investing in NPS now becomes a hassle free process using Moneyfront as your online investment advisor. You can constantly track and review the performance of your NPS contributions. ',
			<>
				<br />
				<br />
			</>,
			'Moneyfront tracks and recommends funds based on the best fund managers, thus helping increase your national pension scheme returns.',
		],
		src: 'howToInvest',
		alt: 'National Pension Scheme',
		imgPosition: 'right',
		primaryLink: '/get-started',
	},
];
